// @flow
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import NotLoggedMenu from './not-logged-menu/NotLoggedMenu';
import LoggedMenu from './logged-menu/LoggedMenu';
import NotificationsMenu from '../notifications/components/NotificationsMenu';
import { Helmet } from 'react-helmet';
import ShoppingCartMenuContainer from '../../shopping-cart/containers/ShoppingCartMenuContainer';
import { Desktop } from '../../../utils/responsive';
import Responsive from 'react-responsive';
import Loading from '../../../elements/Loading/Loading';
import analytics from '../../../analytics';
import { chooseCookieBasedVariant } from '../../ab-test/utils';
import { experiments } from '../../ab-test/experiments';

import style from './Navbar.scss';
import avatarStyle from '../../../assets/styles/avatar.scss';
import buttonStyle from '../../../assets/styles/button.scss';
import icons from '../../../assets/styles/icons.scss';
import logo from '../../../assets/img/logoq-primary.png';
import logo2 from '../../../assets/img/logoq-primary2.png';
import defaultPic from '../../../assets/img/profileplaceholder.jpg';

import type { User } from '../../../entities';
import type { NotificationsState } from '../notifications/duck';
import type { Notification, ShoppingCartItem } from '../../../entities';
import type { Location } from '../../../router';
import type { OrderType } from '../../order/duck';
import type { LocaleState } from '../../locale/duck';
import type { LocalValuesState } from '../../local-values/duck';
import type { Variant } from '../../ab-test/duck';
import type { VirtualItem } from '../../shopping-cart/api';

type Props = {
  +authenticated: boolean;
  +logout: () => void;
  +user: User;
  +isAuthing?: boolean;
  +locale: LocaleState;
  +localValues: LocalValuesState;
  +notificationsState: NotificationsState;
  // +history: History,
  +handleOpenAuthModal: (openLoginView?: boolean) => void;
  +fetchUnseen: () => void;
  +fetchNotifications: () => void;
  +readNotification: (id: string) => void;
  +seeAllNotification: () => void;
  +hideNotification: (id: string) => void;
  +reset: () => void;
  +newRealtimeNotification: (notification: Notification) => void;
  // +router: RouterState,
  +location: Location;
  +fetchOrder: (orderId: string, orderType: OrderType) => void;
  +postCartItemSuccess?: boolean;
  +shoppingCart?: ShoppingCartItem[];
  +virtualShoppingCart: VirtualItem[];
  +virtualShoppingCartInitialized?: boolean;
  +chosenVariants?: { [key: string]: number };
};

type State = {
  // route: HistoryRoute,
  notLoggedOpen: boolean;
  loggedMenuOpen: boolean;
  notificationsOpen: boolean;
  shoppingCartOpen: boolean;
  didMountReached: boolean;
};

export default class Navbar extends Component<Props, State> {
  // historyUnsubscribe: any;
  state = {
    // route: {},
    notLoggedOpen: false,
    loggedMenuOpen: false,
    notificationsOpen: false,
    shoppingCartOpen: false,
    didMountReached: false,
  };

  constructor(props: Props) {
    super(props);
    /*if (!this.state.route.pathname && props.router && props.router.location) {
      this.state.route.pathname = props.router.location.pathname;
    }*/
    /*this.historyUnsubscribe = props.history.listen(route => {
      if (window) window.scrollTo(0, 0);
      this.setState({ route });
      this.closeLoggedMenu();
    });*/
  }

  componentDidMount() {
    this.setState({ didMountReached: true });
  }

  componentDidUpdate(prevProps: Props) {
    const { postCartItemSuccess, virtualShoppingCart, virtualShoppingCartInitialized } = this.props;
    const splitted = this.props.location.pathname.split('/');
    // When user adds an item to any type of cart and user is not at /new-order/quote
    /*if (!prevProps.postCartItemSuccess && postCartItemSuccess && splitted[2] !== 'quote') {
      this.setState({ shoppingCartOpen: true });
    }*/

    /*if (prevProps.virtualShoppingCartInitialized && virtualShoppingCartInitialized &&
      prevProps.virtualShoppingCart && virtualShoppingCart &&
      prevProps.virtualShoppingCart.length < virtualShoppingCart.length) {
      this.setState((state: State) => ({
        shoppingCartOpen: !state.shoppingCartOpen,
        notLoggedOpen: !state.shoppingCartOpen ? false : state.notLoggedOpen,
        notificationsOpen: !state.loggedMenuOpen ? false : state.notificationsOpen,
        loggedMenuOpen: !state.shoppingCartOpen ? false : state.loggedMenuOpen,
      }));
    }*/
  }

  handleCloseNotLoggedMenu(e: Event, openModal?: boolean, openLoginView?: boolean) {
    const { location, handleOpenAuthModal } = this.props;
    const isHome = location.pathname === '/';
    if (isHome && openModal) {
      e.preventDefault();
      handleOpenAuthModal(openLoginView);
    }
    this.setState({
      notLoggedOpen: false,
    });
  }

  handleLoggedMenu() {
    this.setState((state: State) => ({
      loggedMenuOpen: !state.loggedMenuOpen,
      notificationsOpen: !state.loggedMenuOpen ? false : state.notificationsOpen,
      shoppingCartOpen: !state.loggedMenuOpen ? false : state.shoppingCartOpen,
    }));
  }

  handleNotificationsMenu() {
    const { seeAllNotification, notificationsState } = this.props;
    this.setState((state: State) => ({
      notificationsOpen: !state.notificationsOpen,
      loggedMenuOpen: !state.notificationsOpen ? false : state.loggedMenuOpen,
      shoppingCartOpen: !state.loggedMenuOpen ? false : state.shoppingCartOpen,
    }));
    if (notificationsState.unseen) {
      seeAllNotification();
    }
  }

  handleShoppingCartMenu() {
    const { shoppingCartOpen } = this.state;
    const { locale, shoppingCart, localValues } = this.props;
    if (shoppingCartOpen === false && shoppingCart) {
      analytics.fireCustomEvent('Cart Viewed', {
        category: 'Cart',
        action: 'Viewed',
        label: 'CART',
        user_type: 'purchaser',
        user_referrer: window.localStorage.getItem('userReferrer') || '',
        landing_url: window.localStorage.getItem('landingUrl') || '',
        domain_country: locale.domainCountry,
        cart_type: 'cart',
        products: analytics.mapProducts(shoppingCart, localValues.categoriesMap),
      });
    }
    this.setState((state: State) => ({
      shoppingCartOpen: !state.shoppingCartOpen,
      notLoggedOpen: !state.shoppingCartOpen ? false : state.notLoggedOpen,
      notificationsOpen: !state.loggedMenuOpen ? false : state.notificationsOpen,
      loggedMenuOpen: !state.shoppingCartOpen ? false : state.loggedMenuOpen,
    }));
  }

  handleCloseNotificationsMenu() {
    this.setState({
      notificationsOpen: false,
    });
  }

  closeLoggedMenu() {
    this.setState({
      loggedMenuOpen: false,
    });
  }

  handleCloseShoppingCartMenu() {
    this.setState({
      shoppingCartOpen: false,
    });
  }

  componentWillUnmount() {
    /*if (this.historyUnsubscribe) {
      this.historyUnsubscribe();
    }*/
  }

  handleOpenModal(e: Event, openLoginView: boolean) {
    const { handleOpenAuthModal } = this.props;
    e.preventDefault();
    handleOpenAuthModal(openLoginView);
    return false;
  }

  render() {
    const {
      authenticated, user, isAuthing, logout, notificationsState, newRealtimeNotification, location,
      fetchUnseen, fetchNotifications, readNotification, hideNotification, reset, locale, fetchOrder, shoppingCart,
      virtualShoppingCart, chosenVariants,
    } = this.props;

    const { notLoggedOpen, loggedMenuOpen, notificationsOpen, shoppingCartOpen, didMountReached } = this.state;
    const totalQuantityItems = !shoppingCart ? '-' :
      shoppingCart.reduce((acum: number, item: ShoppingCartItem) => acum + item.amount, 0);

    // AB
    /*const chooseFnResult: Variant = chooseCookieBasedVariant(document ? document.cookie : '',
      experiments['navbarBuyButton'].experimentId,
      experiments['navbarBuyButton'].variants);
    const chosenVariantIndex = chosenVariants && chosenVariants['navbarBuyButton'];
    const chosenVariant = typeof chosenVariantIndex === 'number' ?
      experiments['navbarBuyButton'].variants[chosenVariantIndex] : chooseFnResult;

    const abBuyLink = chosenVariant.index === 0 ? '/new-order' : '/new-order/product';*/
    const totalVirtualQuantityItems = !virtualShoppingCart.length ? 0 :
      virtualShoppingCart.reduce((acum: number, item: ShoppingCartItem) => acum + item.amount, 0);

    const unLoggedOptions = (!authenticated || !user) && <Fragment>
      <FormattedMessage id="nav.buyBig">{
        txt => <Link id="buyNow"
                     className={classNames(style.option, style.rightOption, style.buyNowOption
                       /*{ [style.active]: location.pathname === '/new-order' }*/)}
                     to="/">
          {/*<i className={icons.iconBagMedium}/>*/}<span>{txt}</span>
        </Link>
      }</FormattedMessage>
      <FormattedMessage id={locale.domainCountry === 'CO' ? 'nav.earn.CO' : 'nav.earn'}>{
        txt => <Link id="earn"
                     className={classNames(style.option, style.rightOption, style.newFlightOption, style.unLogged
                       /*{ [style.active]: location.pathname === '/new-flight' }*/)}
                     to="/preferences/referral">
          {/*<i className={icons.iconAirplaneMedium}/>*/}<span>{txt}</span>
        </Link>
      }</FormattedMessage>
      <FormattedMessage id="nav.loggedMenu.help">{
        txt => <a id="help"
                  className={classNames(style.option, style.rightOption, style.helpOption, style.visibleFromSmall, style.faqLabel)}
                  target="_blank"
                  href="https://help.qempo.com">
          {/*<i className={icons.symbolQuestionCircle}/>*/}<span>{txt}</span>
        </a>
      }</FormattedMessage>
      {user && (
        <Fragment>
          <Link className={classNames(style.option, style.rightOption, style.optionButton, style.shoppingCartButton,
                 style.last, {[style.active]: shoppingCartOpen})}
                to="/shopping-cart">
            <i className={classNames(icons.iconShoppingCartMedium, style.noMargin)}/>
            <span className={classNames(style.itemQuantity)}>{totalQuantityItems/*totalVirtualQuantityItems*/}</span>
          </Link>
          {/*<button type="button"
                  onClick={this.handleShoppingCartMenu.bind(this)}
                  className={classNames(style.option, style.rightOption, style.optionButton, style.shoppingCartButton,
                    {[style.active]: shoppingCartOpen})}>
            <i className={classNames(icons.iconShoppingCartMedium, style.noMargin)}/>
            <span className={classNames(style.itemQuantity)}>{totalQuantityItems}</span>
          </button>
          <ShoppingCartMenuContainer open={shoppingCartOpen}
                                     closeShoppingCartMenu={this.handleCloseShoppingCartMenu.bind(this)}/>*/}
        </Fragment>
      )}
      <FormattedMessage id="auth.title">{
        txt => <Link id="login"
                     onClick={(e: Event) => this.handleOpenModal(e, true)}
                     className={classNames(style.option, style.rightOption, style.loginOption, style.visibleFromMedium,
                       { [style.active]: location.pathname === '/login' })}
                     to="/login">{txt}</Link>
      }</FormattedMessage>
      <FormattedMessage id="signup.title">{
        txt => <Link id="signup"
                     onClick={(e: Event) => this.handleOpenModal(e, false)}
                     className={classNames(style.option, style.rightOption, style.signUpOption, style.visibleFromMedium,
                       style.last, { [style.active]: location.pathname === '/sign-up' })}
                     to="/sign-up">{txt}</Link>
      }</FormattedMessage>
      {/*<button type="button"
              onClick={(e: Event) => this.setState((prevState: State) => ({ notLoggedOpen: !prevState.notLoggedOpen }))}
              className={classNames(style.option, style.rightOption, style.optionButton, style.notLoggedMenu,
                { [style.active]: notLoggedOpen })}>
        <i className={classNames(icons.iconProfileMedium, style.profile, style.noMargin)}/>
      </button>*/}

      <button type="button"
              onClick={() => this.setState({ notLoggedOpen: !notLoggedOpen })}
              className={classNames(style.visibleUntilMedium,
                style['hamburger--slider'], { [style['is-active']]: notLoggedOpen },
                { [style.notLoggedActive]: notLoggedOpen }, style.option, style.optionButton, style.burger)}>
        <span className={style['hamburger-box']}>
          <span className={classNames(style['hamburger-inner'],
            { [style.notLoggedActive]: notLoggedOpen })}/>
        </span>
      </button>
      <NotLoggedMenu close={this.handleCloseNotLoggedMenu.bind(this)}
                     open={notLoggedOpen}
                     handleOpenModal={this.handleOpenModal.bind(this)}
                     locale={locale}/>
    </Fragment>;
    const loggedOptions = authenticated && user && [
      <FormattedMessage key="buyNow"
                        id="nav.buyBig">{
        txt => <Link id="buyNow"
                     className={classNames(style.option, style.rightOption, style.buyNowOption,
                       style.logged
                       /*{ [style.active]: location.pathname === '/new-order' }*/)}
                     to="/">{/*<i className={icons.iconBagMedium}/>*/}<span
          className={style.visibleFromSmall}>{txt}</span></Link>
      }</FormattedMessage>,
      <FormattedMessage key="earn"
                        id="nav.earn">{
        txt => <Link id="earn"
                     className={classNames(style.option, style.rightOption, style.newFlightOption,
                       style.loggedOn
                       /*{ [style.active]: location.pathname === '/new-flight' }*/)}
                     to="/preferences/referral">{/*<i className={icons.iconAirplaneMedium}/>*/}<span
          className={style.visibleFromSmall}>{txt}</span></Link>
      }</FormattedMessage>,
      <FormattedMessage key="help"
                        id="nav.loggedMenu.help">{
        txt => <a id="help"
                  className={classNames(style.option, style.rightOption, style.visibleFromSmall, style.faqLabel)}
                  target="_blank"
                  href="https://help.qempo.com">
          {/*<i className={icons.symbolQuestionCircle}/>*/}<span>{txt}</span>
        </a>
      }</FormattedMessage>,
      <div key="vr" className={style.verticalLine}/>,
      <button key="notification"
              type="button"
              onClick={this.handleNotificationsMenu.bind(this)}
              className={classNames(style.option, style.rightOption, style.optionButton, style.notificationButton,
                { [style.active]: notificationsOpen })}>
        <i className={classNames(icons.symbolBell, style.noMargin,
          { [style.withUnseen]: notificationsState.unseen })}/>
        {/*<span className={style.visibleFromMedium}>
          <FormattedMessage
            id="nav.notificationsMenu.title"/>
        </span>*/}
      </button>,
      user && (
        <Link key="shoppingCart"
              className={classNames(style.option, style.rightOption, style.optionButton, style.shoppingCartButton, 
                style.last, {[style.active]: shoppingCartOpen})}
              to="/shopping-cart">
          <i className={classNames(icons.iconShoppingCartMedium, style.noMargin)}/>
          <span className={classNames(style.itemQuantity)}>{totalQuantityItems}</span>
        </Link>
        /*<button key="shoppingCart"
                type="button"
                onClick={this.handleShoppingCartMenu.bind(this)}
                className={classNames(style.option, style.rightOption, style.optionButton, style.shoppingCartButton,
                  style.loggedOn, { [style.active]: shoppingCartOpen })}>
          <i className={classNames(icons.iconShoppingCartMedium, style.noMargin)}/>
          {shoppingCart && <span className={classNames(style.itemQuantity)}>{totalVirtualQuantityItems}</span>}
        </button>*/
      ),
      <aside key="loggedOptionsWrap"
             onClick={this.handleLoggedMenu.bind(this)}
             className={classNames(style.loggedOptionsWrap,
               { [style.active]: loggedMenuOpen })}>
        <img src={user.image || defaultPic}
             className={classNames(avatarStyle.avatar, style.avatar)}
             alt={`${user.firstName} ${user.lastName}`}/>
        {/*<i className={loggedMenuOpen ? icons.iconChevronUpMedium : icons.iconChevronDownMedium}/>*/}
      </aside>,
      /*false && <button key="hamburger"
                       type="button"
                       onClick={this.handleLoggedMenu.bind(this)}
                       className={classNames(style.visibleUntilMedium,
                         style['hamburger--slider'], { [style['is-active']]: loggedMenuOpen },
                         { [style.notLoggedActive]: loggedMenuOpen }, style.burger)}>
        <span className={style['hamburger-box']}>
          <span className={classNames(style['hamburger-inner'],
            { [style.notLoggedActive]: loggedMenuOpen })}/>
        </span>
      </button>,*/
      <LoggedMenu key="loggedMenu"
                  open={loggedMenuOpen}
                  user={user}
                  locale={locale}
                  close={this.closeLoggedMenu.bind(this)}
                  logout={logout}/>,
      <NotificationsMenu key="notificationsMenu"
                         open={notificationsOpen}
                         fetchUnseen={fetchUnseen}
                         newRealtimeNotification={newRealtimeNotification}
                         fetchNotifications={fetchNotifications}
                         readNotification={readNotification}
                         hideNotification={hideNotification}
                         reset={reset}
                         user={user}
                         closeNotificationsMenu={this.handleCloseNotificationsMenu.bind(this)}
                         notificationsState={notificationsState}
                         fetchOrder={fetchOrder}
                         location={location}
                         locale={locale}/>,
      /*<ShoppingCartMenuContainer key="shoppingCartMenu"
                                 open={shoppingCartOpen}
                                 closeShoppingCartMenu={this.handleCloseShoppingCartMenu.bind(this)}/>,*/
    ];
    const isHome = location.pathname === '/';
    return (
      <Fragment>
        {/*<Helmet>
          <style type="text/css">{`
            body {
              padding-top: 72px;
            }
          `}</style>
        </Helmet>*/}
        <nav className={classNames(style.navbarWrap,
          { [style.transparent]: isHome })}>
          <Desktop>
            {(notificationsOpen || shoppingCartOpen || loggedMenuOpen) &&
            <Fragment>
              {/*<Helmet key="helmet">
                <style type="text/css">{`body {
                overflow: hidden!important;
              }`}</style>
              </Helmet>*/}
              <section className={classNames(style.veil)}/>
            </Fragment>}
          </Desktop>
          <Responsive maxWidth={991}>
            {(notificationsOpen || shoppingCartOpen || loggedMenuOpen || notLoggedOpen) &&
            <Fragment>
              {/*<Helmet key="helmet">
                <style type="text/css">{`body {
                overflow: hidden!important;
              }`}</style>
              </Helmet>*/}
              <section className={classNames(style.veil)}/>
            </Fragment>}
          </Responsive>
          <section className={style.navbarContent}>
            <Link className={style.imageWrap}
                  onClick={_ => this.handleCloseNotificationsMenu()}
                  to="/">
              <img className={style.logo}
                   src={logo}
                   alt="Qempo"/>
              <img className={style.logoq}
                   src={logo2}
                   alt="Qempo"/>
            </Link>
            {/*<Link className={classNames(style.option, style.leftOption, style.first,
            { [style.alwaysVisible]: !user })}
                to="/new-order">
            <i className={icons.iconBagMedium}/>
            <FormattedMessage id="nav.buySmall">{
              txt => <span className={style.medium}>{txt}</span>
            }</FormattedMessage>
            <FormattedMessage id="nav.buyBig"/>
          </Link>*/}
            {/*<Link className={classNames(style.leftOption, style.leftLimit, style.orange)}
                to="/new-flight">
            <i className={icons.iconAirplaneMedium}/>
            <span className={style.medium}>
              <FormattedMessage id="nav.travelBig"/>
            </span>
            <span className={style.large}>
              <FormattedMessage id="nav.travelBig"/>
            </span>
          </Link>*/}
            {(!didMountReached || isAuthing) && <Loading type="circle"
                                                         className={style.loading}/>}
            {didMountReached && !isAuthing && unLoggedOptions}
            {didMountReached && !isAuthing && loggedOptions}
          </section>
        </nav>
      </Fragment>
    );
  }
}


Navbar.propTypes = {
  authenticated: PropTypes.bool,
  logout: PropTypes.func.isRequired,
  user: PropTypes.object,
  isAuthing: PropTypes.bool,
  notificationsState: PropTypes.object.isRequired,
  // history: PropTypes.object.isRequired,
  handleOpenAuthModal: PropTypes.func.isRequired,
  fetchUnseen: PropTypes.func.isRequired,
  fetchNotifications: PropTypes.func.isRequired,
  readNotification: PropTypes.func.isRequired,
  seeAllNotification: PropTypes.func.isRequired,
  hideNotification: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  newRealtimeNotification: PropTypes.func.isRequired,
  // router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  fetchOrder: PropTypes.func.isRequired,
  postCartItemSuccess: PropTypes.bool,
  shoppingCart: PropTypes.array,
  virtualShoppingCart: PropTypes.array.isRequired,
  virtualShoppingCartInitialized: PropTypes.bool,
  chosenVariants: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/modules/navbar/components/Navbar.jsx